import {
  Citrus,
  Carrot,
  Wheat,
  Package,
  Sprout,
  Blend,
  Leaf,
  Flower2,
  Egg,
} from "lucide-react";
import { OTHER_PRODUCT_RANGE } from "@/constants/otherProductRange";

const CATEGORY_ICONS = {
  Fruits: Citrus,
  Vegetables: Carrot,
  Grains: Wheat,
  Pulses: Package,
  "Nuts & Seeds": Sprout,
  "Spices & Powders": Blend,
  "Herbs & Leaves": Leaf,
  "Rose & Natural Products": Flower2,
  "Poultry & Dairy": Egg,
};

export const OtherProductRange = () => {
  return (
    <section data-testid="other-product-range" className="bg-[#F2F9F5] border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <h2
          data-testid="other-product-range-title"
          className="font-heading text-2xl sm:text-3xl font-bold text-[#042D1F] mb-10"
        >
          Other Product Range
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {OTHER_PRODUCT_RANGE.map(({ category, items, testId }) => {
            const Icon = CATEGORY_ICONS[category] || Package;
            return (
              <div key={category} data-testid={testId} className="rounded-xl border border-[#E2E8F0] bg-white p-6">
                <div className="flex items-center gap-2.5 mb-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0B4F37]/10 text-[#0B4F37]">
                    <Icon className="h-[18px] w-[18px]" strokeWidth={1.8} />
                  </span>
                  <h3 className="font-heading text-base font-semibold text-[#042D1F]">{category}</h3>
                </div>
                <div className="flex flex-wrap gap-2">
                  {items.map((item) => (
                    <span
                      key={item}
                      className="text-sm text-[#0B4F37] bg-[#F2F9F5] border border-[#E2E8F0] rounded-full px-3 py-1"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
